const TextHighlightsDisplay = ({ highlights, isLoading, error }) => {
  return (
    <div className="document-highlights">
      <h4>Document Text Highlights</h4>
      <i>Text highlights might be inaccurate or incomplete. For the most accurate results, please refer directly to the document.</i>
      {isLoading && (<div className="highlights-loading"><i className='bx bx-loader-alt bx-spin'></i> Loading...</div>)}
      {error && (<div className="highlights-error"><i className='bx bx-error-circle'></i> {error}</div>)}
      {!isLoading && !error && (!highlights || highlights.length === 0) && (<div className="no-highlights">No text highlights.</div>)}
      {!isLoading && !error && highlights?.length > 0 && (
        <div className="highlights-list">
          {highlights.slice(0, 10).map((h, idx) => (
            <div className="highlight-item" key={idx} dangerouslySetInnerHTML={{ __html: h }}></div>
          ))}
        </div>
      )}
    </div>
  );
};

export default TextHighlightsDisplay;